export type TDisplay = 'text' | 'peopleModal' | 'tabs' | 'action button';

type ActionButton = {
    position: string;
    negative: string;
};

export const INTERESTS = [
    'seeking jobs',
    'hiring creatives',
    'influencers',
    'creative campaigns',
    'contests',
    'connect with creators',
    'casting calls',
    'creative collaboration',
    'creative events',
    'brand collboration',
];

export const ROLES = [
    'brand',
    'actor',
    'influencer',
    'filmmaker',
    'casting director',
    'graphic designer',
    'event coordinator',
    'ui/ux designer',
    'web designer',
    'motion graphics designer',
    'illustrator',
    'sculptor',
    'photographer',
    'printmaker',
    'concept artist',
    'cartoonist',
    'tattoo artist',
    'art director',
    'gallery curator',
    'actor',
    'skit maker',
    'artist',
    'actress',
    'child actor',
    'skit maker',
    'musician',
    'singer',
    'composer',
    'voice actor',
    'video editor',
    'animator',
    'vfx artist',
    'sound designer',
    'multimedia artist',
    'content creator (youtube, tiktok, etc.)',
    'content creator',
    'screenwriter',
    'casting director',
    'make-up artist',
    'rapper',
    'podcast host',
    'poet',
    'blogger',
    'others',
    'gaffer',
    'director',
    'producer',
    'cinematographer',
    'assistant director',
    'script supervisor',
    'production designer',
    'costume designer',
    'editor',
    'location manager',
    'production assistant',
    'stunt coordinator',
    'special effects artist',
    'prop master',
    'sound mixer',
    'grip',
    'best boy',
    'key grip',
    'dolly grip',
    'screen writer',
    'film festival',
    'event coordinator',
    'concert organizer',
];

export interface IIntroductionType {
    displayType: TDisplay;
    displayTitle?: string;
    displaySubtitle?: string;
    actionText?: string;
    canSkip?: boolean;
    options?: string[];
    actionButtons?: ActionButton[];
    field_name?: string;
    instruction?: string;
    hideArrow?: boolean;
}

export const introductionSteps: IIntroductionType[] = [
    {
        displayType: 'text',
        displayTitle: `Hi, #{user}#`,
        displaySubtitle: 'Welcome to Thspian, where creativity meets collaboration.',
        actionText: "Let's get you situated ...",
        canSkip: false,
    },
    {
        displayType: 'tabs',
        displayTitle: 'How can we address you?',
        options: ROLES,
        canSkip: false,
        field_name: 'user_type',
        instruction: 'Select at least one.',
    },
    {
        displayType: 'tabs',
        displayTitle: 'What interests you?',
        options: INTERESTS,
        canSkip: false,
        field_name: 'interest',
        instruction: 'Select at least one',
    },
    {
        displayType: 'peopleModal',
        displayTitle: 'Based on your selection',
        displaySubtitle: 'Here are some thspians you might want to keep an eye on',
        canSkip: false,
    },
    {
        displayType: 'action button',
        displayTitle: 'Finally, we would like to show you around',
        displaySubtitle: 'It would only take a few minutes 😊',
        actionButtons: [
            {
                negative: 'No, I know my way around',
                position: 'Yes, please show me around',
            },
        ],
        field_name: 'show_app_guide',
    },
];

export const projectCreationSeps: IIntroductionType[] = [
    {
        displayType: 'text',
        displayTitle: `So, What's the fuzz about publishing anyway...😎 ?`,
        displaySubtitle: "Here's a quick rundown...",
        canSkip: false,
    },
    {
        displayType: 'text',
        displayTitle: `Once you publish, 🚀`,
        displaySubtitle: 'Your project will now appear in feeds and searches',
        actionText: 'Folks will be able to catch your latest creation 😃',
        canSkip: false,
    },
    {
        displayType: 'text',
        displayTitle: `Contests...🗳️`,
        displaySubtitle: 'Published projects are eligible to be submitted to contests',
        actionText: "Otherwise, you won't see the project as an option while submitting 🥶",
        canSkip: false,
    },
    {
        displayType: 'text',
        displayTitle: `Change your mind?`,
        displaySubtitle: 'You can always change the publish settings on your project.',
        actionText: 'Go to project -> select the said project -> settings -> toggle off and click save.',
        canSkip: false,
    },
    {
        displayType: 'action button',
        displayTitle: 'Now that you are all caught up,',
        displaySubtitle: 'Would you still like to publish? 😊',
        actionButtons: [
            {
                negative: 'No, just not yet',
                position: 'Yes, please go ahead',
            },
        ],
        field_name: 'show_project_guide',
    },
];
